/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {MenuComponent} from '../../../assets/ts/components'
import {ID, KTSVG, QUERIES} from '../../../helpers'
// import {useListView} from '../../../../app/pages/ListUsers/users-list/core/ListViewProvider'
import {useQueryResponse} from '../../../../app/pages/ListUsers/users-list/core/QueryResponseProvider'
import {deleteUser} from '../../../../app/pages/ListUsers/users-list/core/_requests'
import {Link} from 'react-router-dom'
import {useLang} from '../../../i18n/Metronici18n'
import {useIntl} from 'react-intl'

type Props = {
  id: ID
}

const MainOrderActionsCell: FC<Props> = ({id}) => {
  // const {setItemIdForUpdate} = useListView()
  const {query} = useQueryResponse()
  const queryClient = useQueryClient()
  const locale: string = useLang()

  // const location = useLocation()
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const deleteItem = useMutation(() => deleteUser(id), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
    },
  })
  const intl = useIntl()
  return (
    <>
      <a
        href='#'
        className='btn btn-light btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement={locale === 'ar' ? 'bottom-start' : 'bottom-end'}
      >
        <KTSVG path='/media/icons/duotune/print/dots.svg' className='svg-icon-4 ml-5' />{' '}
      </a>
      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        data-kt-menu='true'
      >
        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <Link className='menu-link px-3' to={`/main-orders/${id}`}>
            {intl.formatMessage({id: 'ECOMMERCE.COMMON.DETAILS'})}
          </Link>
        </div>
        {/* end::Menu item */}

        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <Link className='menu-link px-3' to={`/main-orders/tracking/${id}`}>
            {intl.formatMessage({id: 'ECOMMERCE.ORDER.TRACKING'})}
          </Link>
        </div>
        {/* end::Menu item */}
        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <Link className='menu-link px-3' to={`/main-orders/${id}/orders`}>
            {intl.formatMessage({id: 'ECOMMERCE.ORDER.SUB.ORDERS'})}
          </Link>
        </div>
        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
    </>
  )
}

export {MainOrderActionsCell}
